import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Form as FinalForm, Field } from "react-final-form";
import { Alert, Button, Col, Form, FormGroup, Row } from "reactstrap";
import { FORM_ERROR } from "final-form";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import {
  CaboloStatusEnum,
  IcaboloRecodingFormValues,
  LanguagePair,
} from "../../app/models/cabolo";
import Loader from "../common/Loader";
import MultiSelectCabolo from "../common/MultiSelectCabolo";
import TextInput from "../common/TextInput";
import GenericModal from "../common/GenericModal";
import LoaderModal from "../common/LoaderModal";
import { set } from "mobx";

interface Props {
  toggle: () => void;
}

export const CaboloForm: React.FC<Props> = ({ toggle }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [recordingForm, setRecordingForm] =
    useState<IcaboloRecodingFormValues | null>(null);
  const [t] = useTranslation(
    ["cabolo", "translation", "features"],
    translationHookOptions
  );
  const {
    caboloMeetigInfo,
    getSettingCabolo,
    caboloRecodingSettings,
    resetSettingCabolo,
    startRecordingCabolo,
    CaboloStatus,
    stopRecordingCabolo,
    pauseRecordingCabolo,
    resumeRecordingCabolo,
    startInterruptedRecordingCabolo
  } = rootStore.caboloStore;
  const { attendingMeeting } = rootStore.playerStore;
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [languagePairs, setLanguagePairs] = useState<LanguagePair[]>([]);

  const ResolveLanguageModel = (Language: string, name: string) => {
    switch (Language) {
      case "ita":
        return t("it-IT", { ns: "translation" });
      case "eng":
        return t("en-US", { ns: "translation" });
      case "fra":
        return t("fr-FR", { ns: "translation" });

      default:
        return name;
    }
  };

  // const ResolveLanguagePairs = (transcriptionModelId: number) => {
  //   if (!caboloRecodingSettings) return;

  //   const model = caboloRecodingSettings.transcriptionModels.find(
  //     (x) => x.id === transcriptionModelId
  //   );
  //   if (!model) return;

  //   switch (model.lang) {
  //     case "ita":
  //     case "eng": {
  //       const filtered = caboloRecodingSettings.languagePairs.find(
  //         (x) => x.sourceLanguageId === model.lang
  //       );

  //       setLanguagePairs(filtered?.targetLanguageId ? [filtered] : []);

  //       if (filtered) {
  //         const selected = [filtered.targetLanguageId];

  //         setRecordingForm((prev) =>
  //           prev
  //             ? {
  //                 ...prev,
  //                 transcriptionModelId,
  //                 languageTranscriptionSelected: selected,
  //               }
  //             : null
  //         );
  //       }
  //       break;
  //     }

  //     case "lid": {
  //       setLanguagePairs(caboloRecodingSettings.languagePairs);

  //       setRecordingForm((prev) =>
  //         prev
  //           ? {
  //               ...prev,
  //               transcriptionModelId,
  //               // opzionalmente resetta a vuoto o mantieni quello che già c'è
  //               languageTranscriptionSelected:
  //                 prev.languageTranscriptionSelected ?? [],
  //             }
  //           : null
  //       );
  //       break;
  //     }

  //     default:
  //       // Puoi opzionalmente pulire anche qui
  //       setLanguagePairs([]);
  //       setRecordingForm((prev) =>
  //         prev
  //           ? {
  //               ...prev,
  //               transcriptionModelId,
  //               languageTranscriptionSelected: [],
  //             }
  //           : null
  //       );
  //       break;
  //   }
  // };


  const ResolveLanguagePairs = (transcriptionModelId: number) => {
    if (!caboloRecodingSettings) return;
  
    const model = caboloRecodingSettings.transcriptionModels.find(
      (x) => x.id === transcriptionModelId
    );
    if (!model) return;
  
    const currentAudioDeviceId = (() => {
      const el = document.getElementById("audioDeviceId") as HTMLSelectElement | null;
      const val = el?.value;
      const parsed = parseInt(val ?? "");
      return isNaN(parsed) || parsed === 0
        ? recordingForm?.audioDeviceId ?? 0
        : parsed;
    })();
  
    switch (model.lang) {
      case "ita":
      case "eng": {
        // const filtered = caboloRecodingSettings.languagePairs.find(
        //   (x) => x.sourceLanguageId === model.lang
        // );
        // così in caso di una terz alingua diventa più generico
        const filtered = caboloRecodingSettings.languagePairs.find(
          (x) => x.targetLanguageId !== model.lang
        );
  
        setLanguagePairs(filtered?.targetLanguageId ? [filtered] : []);
  
        if (filtered) {
          const selected = [filtered.targetLanguageId];
  
          setRecordingForm((prev) =>
            prev
              ? {
                  ...prev,
                  audioDeviceId: currentAudioDeviceId,
                  transcriptionModelId,
                  languageTranscriptionSelected: selected,
                }
              : null
          );
        }
        break;
      }
  
      case "lid": {
        setLanguagePairs(caboloRecodingSettings.languagePairs);
  
        setRecordingForm((prev) =>
          prev
            ? {
                ...prev,
                audioDeviceId: currentAudioDeviceId,
                transcriptionModelId,
                languageTranscriptionSelected:
                  prev.languageTranscriptionSelected ?? [],
              }
            : null
        );
        break;
      }
  
      default:
        setLanguagePairs([]);
        setRecordingForm((prev) =>
          prev
            ? {
                ...prev,
                audioDeviceId: currentAudioDeviceId,
                transcriptionModelId,
                languageTranscriptionSelected: [],
              }
            : null
        );
        break;
    }
  };
  
  
  


  useEffect(() => {
    if (!caboloMeetigInfo || !attendingMeeting) return;
    getSettingCabolo(caboloMeetigInfo.caboloId, attendingMeeting.id).then(
      (dto) => {
        if (dto) {
          const initialValues: IcaboloRecodingFormValues = {
            caboloId: dto.caboloId,
            meetingId: dto.meetingId,
            audioDeviceId: dto.audioDeviceId,
            transcriptionModelId: dto.transcriptionModelId,
            languageTranscriptionSelected: dto.languagePairSelected,
            title: attendingMeeting.title, // RECUPERARE IL TITLE DALLA RIUNIONE IN CORSO
          };
          setRecordingForm(initialValues);
        }
      }
    );
    return () => {
      resetSettingCabolo();
    };
  }, [getSettingCabolo]);

  useEffect(() => {
    if (recordingForm?.transcriptionModelId) {
      ResolveLanguagePairs(recordingForm.transcriptionModelId);
    }
  }, [recordingForm?.transcriptionModelId]);

  if (!caboloRecodingSettings) return <Loader></Loader>;

  return (
    <>
      {CaboloStatus === CaboloStatusEnum.STATE_READY && (
        <>
          <FinalForm
            initialValues={recordingForm}
            onSubmit={(values: IcaboloRecodingFormValues) => {
              var formValues: IcaboloRecodingFormValues = {
                caboloId: values.caboloId,
                meetingId: values.meetingId,
                title: values.title,
                audioDeviceId: values.audioDeviceId,
                transcriptionModelId: values.transcriptionModelId,
                languageTranscriptionSelected:
                  values.languageTranscriptionSelected, // uso il nuovo stato
              };
              // console.log("FORM:", JSON.stringify(formValues));
              setIsModalLoader(true);
              startRecordingCabolo(formValues)
                .then(() => {
                  toggle();
                })
                .catch()
                .finally(() => {
                  setIsModalLoader(false);
                });
            }}
            validate={(values) => {

              let errors = {};
              let errorNum = 0;
              if (!values.audioDeviceId || values.audioDeviceId === 0)
                errorNum++;
              if (
                !values.transcriptionModelId ||
                values.transcriptionModelId === 0
              )
                errorNum++;
              if (!values.title || values.title === "") errorNum++;
              if (errorNum === 0) return errors;
              else return { count: errorNum };
            }}
            render={({
              handleSubmit,
              submitting,
              submitError,
              invalid,
              pristine,
              dirtySinceLastSubmit,
              touched,
            }) => (
              <Form onSubmit={handleSubmit} role="form">
                <Row>
                  <Col>
                    <FormGroup className="form-group input-group-lg">
                      <label className="form-control-label" htmlFor="title">
                        {t("label_title_registration", { ns: "cabolo" })}
                      </label>
                      <Field
                        className="form-control"
                        name="title"
                        component={TextInput}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="audioDeviceId"
                      >
                        {t("label_audio_devices", { ns: "cabolo" })}
                      </label>
                      <Field
                        id="audioDeviceId"
                        name="audioDeviceId"
                        component="select"
                        className="form-control-alternative form-control"
                        autoComplete="off"
                        parse={(value) => parseInt(value)}
                      >
                        <option value="0">---</option>
                        {caboloRecodingSettings.audioDevices.map((l) => (
                          <option key={l.id} value={l.id}>
                            {t(`${l.name}`)}
                          </option>
                        ))}
                      </Field>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="transcriptionModelId"
                      >
                        {t("label_transcription_model", { ns: "cabolo" })}
                      </label>
                      <Field name="transcriptionModelId">
                        {({ input }) => (
                          <select
                            {...input}
                            className="form-control-alternative form-control"
                            onChange={(e) => {
                              const selectedModel = parseInt(e.target.value);
                              input.onChange(selectedModel); // necessario per aggiornare il form
                              ResolveLanguagePairs(selectedModel);
                            }}
                          >
                            <option value="0">---</option>
                            {caboloRecodingSettings.transcriptionModels.map(
                              (l) => (
                                <option key={l.id} value={l.id}>
                                  {/* {t(`${l.name}`)} */}
                                  {ResolveLanguageModel(l.lang, l.name)}
                                </option>
                              )
                            )}
                          </select>
                        )}
                      </Field>
                    </FormGroup>
                  </Col>
                </Row>
                {languagePairs.length > 0 && (
                  <>
                    <Row>
                      <Col>
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="languageTranscriptionDefault"
                          >
                            {t("label_languageTranscription", { ns: "cabolo" })}
                          </label>
                          <Field name="languageTranscriptionSelected">
                            {({ input }) => (
                              <MultiSelectCabolo
                                input={input}
                                options={languagePairs}
                                languagePairSelected={
                                  recordingForm?.languageTranscriptionSelected ||
                                  []
                                }
                              />
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                  </>
                )}
                <Row>
                  <Col className="d-flex justify-content-end">
                    <div style={{ marginRight: "1rem" }}>
                      <Button
                        disabled={invalid && !dirtySinceLastSubmit}
                        className={classNames(
                          "genericButton",
                          `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                            theme!.buttonTextColor
                          }`
                        )}
                        type="submit"
                      >
                        {t("btn_start_recording", { ns: "cabolo" })}
                      </Button>
                    </div>
                    <div>
                      <Button
                        className={classNames(
                          "genericButton",
                          `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                            theme!.buttonTextColor
                          }`
                        )}
                        onClick={toggle}
                      >
                        {t("cancel", { ns: "translation" })}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          />
        </>
      )}

      {CaboloStatus === CaboloStatusEnum.STATE_PLAYING && (
        <>
          <Row style={{marginBottom:"2rem"}}>
            <Col>
              {/* <Alert color="info"> */}
                {t("alert_recording_in_progress", { ns: "cabolo" })}
              {/* </Alert> */}
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-end">
              <div style={{ marginRight: "1rem" }}>
                <Button
                  className={classNames(
                    "genericButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  onClick={() => {
                    setIsModalLoader(true);
                    pauseRecordingCabolo()
                      .then(() => {
                        toggle();
                      })
                      .catch()
                      .finally(() => {
                        setIsModalLoader(false);
                      });
                  }}
                >
                  {t("btn_pause_recording", { ns: "cabolo" })}
                </Button>
              </div>
              <div style={{ marginRight: "1rem" }}>
                <Button
                  className={classNames(
                    "genericButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  onClick={() => {
                    setIsModalLoader(true);
                    stopRecordingCabolo()
                      .then(() => {
                        toggle();
                      })
                      .catch()
                      .finally(() => {
                        setIsModalLoader(false);
                      });
                  }}
                >
                  {t("btn_stop_recording", { ns: "cabolo" })}
                </Button>
              </div>
              <div>
                <Button
                  className={classNames(
                    "genericButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  onClick={toggle}
                >
                  {t("cancel", { ns: "translation" })}
                </Button>
              </div>
            </Col>
          </Row>
        </>
      )}

      {CaboloStatus === CaboloStatusEnum.STATE_PAUSED && (
        <>
           <Row style={{marginBottom:"2rem"}}>
            <Col>
              {/* <Alert color="info"> */}
                {t("alert_recording_paused", { ns: "cabolo" })}
              {/* </Alert> */}
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-end">
              <div style={{ marginRight: "1rem" }}>
                <Button
                  className={classNames(
                    "genericButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  onClick={() => {
                    setIsModalLoader(true);
                    resumeRecordingCabolo()
                      .then(() => {
                        toggle();
                      })
                      .catch()
                      .finally(() => {
                        setIsModalLoader(false);
                      });
                  }}
                >
                  {t("btn_resume_recording", { ns: "cabolo" })}
                </Button>
              </div>
              <div style={{ marginRight: "1rem" }}>
                <Button
                  className={classNames(
                    "genericButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  onClick={() => {
                    setIsModalLoader(true);
                    stopRecordingCabolo()
                      .then(() => {
                        toggle();
                      })
                      .catch()
                      .finally(() => {
                        setIsModalLoader(false);
                      });
                  }}
                >
                  {t("btn_stop_recording", { ns: "cabolo" })}
                </Button>
              </div>
              <div>
                <Button
                  className={classNames(
                    "genericButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  onClick={toggle}
                >
                  {t("cancel", { ns: "translation" })}
                </Button>
              </div>
            </Col>
          </Row>
        </>
      )}
   {CaboloStatus === CaboloStatusEnum.STATE_INTERRUPTED && (
        <>
           <Row style={{marginBottom:"2rem"}}>
            <Col>
              {/* <Alert color="info"> */}
                {t("alert_recording_interrupted", { ns: "cabolo" })}
              {/* </Alert> */}
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-end">
              <div style={{ marginRight: "1rem" }}>
                <Button
                  className={classNames(
                    "genericButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  onClick={() => {
                    setIsModalLoader(true);
                    startInterruptedRecordingCabolo()
                      .then(() => {
                        toggle();
                      })
                      .catch()
                      .finally(() => {
                        setIsModalLoader(false);
                      });
                  }}
                >
                  {t("btn_resume_recording", { ns: "cabolo" })}
                </Button>
              </div>
              <div>
                <Button
                  className={classNames(
                    "genericButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  onClick={toggle}
                >
                  {t("cancel", { ns: "translation" })}
                </Button>
              </div>
            </Col>
          </Row>
        </>
      )}
      <LoaderModal
        size="sm"
        title=""
        message={t("waiting", { ns: "features" })}
        isOpen={isModalLoader}
        toggle={() => {}}
      />
    </>
  );
};
export default observer(CaboloForm);
